// @ts-nocheck
import PropTypes from "prop-types";
import {BaseModal} from "@/components";
import "../../styles/global.css";

// Legacy-named wrapper kept for existing call-sites.
// Forwards to the new BaseModal while preserving the old API shape
// (state/closeModal/width/maskStyle/wrapClassName/closable).
const LegacyBaseModal = ({children, title, state, closeModal, width, className, closable = true, transparent = false}) => {
  // Map legacy numeric/string width to size token; default md.
  const size = (() => {
    if (!width) return "md";
    const n = typeof width === "string" ? parseInt(width, 10) : width;
    if (Number.isNaN(n)) return "md";
    if (n <= 400) return "sm";
    if (n <= 640) return "md";
    if (n <= 900) return "lg";
    return "xl";
  })();

  return (
    <BaseModal
      open={!!state}
      onClose={closeModal}
      title={title}
      size={size}
      closeOnOverlayClick={closable}
      closeOnEscape={closable}
      className={className}
      transparent={transparent}
    >
      {children}
    </BaseModal>
  );
};

LegacyBaseModal.propTypes = {
  children: PropTypes.node,
  title: PropTypes.node,
  state: PropTypes.bool,
  closeModal: PropTypes.func,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  closable: PropTypes.bool,
};

export default LegacyBaseModal;
